// Transport codes remain stable identifiers; report UI labels follow locale.
// Custom managed method codes remain identifiable when no built-in label exists.
const arabic: Readonly<Record<string, string>> = {
  booking: 'الحجز',
  branch: 'الفرع',
  company: 'الشركة',
  RENT_PAYMENT: 'دفعة إيجار',
  RENT_REFUND: 'رد إيجار',
  DEPOSIT_COLLECTION: 'تحصيل تأمين',
  DEPOSIT_REFUND: 'رد تأمين',
  DEPOSIT_RETAINED: 'احتفاظ بالتأمين',
  EXPENSE: 'مصروف',
  SUPPLIER_REFUND: 'استرداد من المورد',
  REVERSAL: 'عكس قيد',
  rent_received: 'إيجار مقبوض',
  rent_returned: 'إيجار مردود',
  deposit_received: 'تأمين محصل',
  deposit_returned: 'تأمين مردود',
  deposit_retained: 'تأمين محتفظ به',
  expense_paid: 'مصروف مدفوع',
  supplier_returned: 'استرداد من المورد',
  cash_movement: 'حركة نقدية',
  pending: 'معلق',
  CONFIRMED: 'مؤكد',
  PENDING_VERIFICATION: 'بانتظار التحقق',
  NEEDS_CORRECTION: 'يحتاج تصحيحًا',
  WITHDRAWN: 'مسحوب',
  CASH: 'نقدي',
  BANK_TRANSFER: 'تحويل بنكي',
  CARD: 'بطاقة',
  PAYMENT_LINK: 'رابط دفع',
  OTHER_NON_CASH: 'غير نقدي آخر',
  DRAFT: 'مسودة',
  RESERVED: 'محجوز',
  ACTIVE: 'نشط',
  COMPLETED: 'مكتمل',
  CANCELLED: 'ملغى',
  ENDED_EARLY: 'منتهٍ مبكرًا',
  NO_SHOW: 'عدم الحضور',
  Draft: 'مسودة',
  Reserved: 'محجوز',
  Active: 'نشط',
  Completed: 'مكتمل',
  Cancelled: 'ملغى',
  'Ended early': 'منتهٍ مبكرًا',
  'No-show': 'عدم الحضور',
  created: 'أُنشئ',
  starting: 'يبدأ',
  overlapping: 'متداخل',
  cancellation: 'إلغاء',
  no_show: 'عدم حضور',
  early_exit: 'خروج مبكر',
};

export const reportCode = (locale: 'ar' | 'en', code: string): string =>
  locale === 'ar' ? (arabic[code] ?? code) : code;
